// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/icon-show-password.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/icon-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/images/bg-scratchcard.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/images/coupon-vector.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/gifs/party.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body:has(.internal) {
    display: flex;
    flex-direction: column;
}

.internal {
    max-width: 1328px;
    padding: 0 24px;
    margin: 0 auto;
    color: var(--color-contrast-dark-gray);
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
}

.internal > .container {
    gap: 90px;
}

.internal .container .comp-title strong {
    color: var(--color-primary-red);
}

.internal .container .comp-title > .p1-paragraph {
    color: var(--color-contrast-dark-gray);
}

@media (max-width: 768px) {
    .internal .container {
        gap: 50px;
    }
}

/* rules */
.rules {
    max-width: 900px;
    color: var(--color-contrast-dark-gray);
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.rules .buttons {
    margin-top: 58px;
}

/* contact us */
.contact-us {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
}

.contact-us .form {
    max-width: 900px;
}

/* form component */
.form {
    max-width: 600px;
    width: 100%;
}

.form:has(.form-sent-message) {
    max-width: 688px;
}

.form .form-sent-message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;
}

.form .form-container {
    background-color: var(--color-primary-light-gray);
    margin-bottom: 56px;
    border: 1.5px solid var(--color-primary-offwhite);
    border-radius: 24px;
    padding: 40px;
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.form-container .title {
    font-family: var(--font-headline-1);
    font-weight: 600;
    font-size: var(--font-size-h5);
    line-height: var(--line-height-h3);
    letter-spacing: var(--letter-spacing-normal);
    color: var(--color-contrast-dark-gray);
}

.form-container .fields {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.form-container .fields .field {
    width: 100%;
    position: relative;
}

.form-container .fields .field.checkbox-field {
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
}

.fields .field:not(.checkbox-field) label {
    font-size: 14px;
    line-height: 140%;
    color: var(--color-contrast-dark-gray);
    position: absolute;
    top: 12px;
    left: 18px;
}

.fields .field.checkbox-field label {
    padding-top: 2px;
    font-size: 12px;
    line-height: 140%;
    color: var(--color-contrast-dark-gray);
}

.fields .field input:not([type="checkbox"]),
.fields .field textarea {
    width: 100%;
    min-height: 78px;
    padding: 42px 18px 12px;
    border: 1.5px solid var(--color-primary-offwhite);
    border-radius: 8px;
    font-size: 18px;
    line-height: 24px;
    color: var(--color-contrast-dark-gray);
}

.fields .field textarea {
    min-height: 200px;
}

.fields .field .toggle-password {
    width: 28px;
    height: 80px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    background-size: contain;
    position: absolute;
    top: 0;
    right: 20px;
    transition: background-image ease-in 0.2s;
}

.fields .field .help-text {
    padding: 15px 0;
}

.fields .field .help-text ul {
    padding-left: 20px;
    margin: 0;
}

.fields .field input[type="checkbox"] {
    width: 24px;
    height: 24px;
    background: var(--color-primary-white) url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
    margin: 0;
    border: 1.5px solid #DD1D21;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color ease-in 0.2s;
    appearance: none;
    -webkit-appearance: none;
}

.fields .field input[type="checkbox"]:checked {
    background-color: var(--color-primary-red);
}

.fields .field .error,
.error-message {
    margin: 18px 0;
    font-family: var(--font-headline-1);
    font-size: 12px;
    line-height: 140%;
    color: var(--color-primary-red);
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.fields a {
    font-size: 12px;
    line-height: 140%;
    color: #1D85B9;
    text-decoration: underline;
}

.internal .extra-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.internal .extra-container .title {
    color: var(--color-primary-red);
}

.internal .extra-container .title b {
    color: var(--color-contrast-dark-gray);
}

.internal .extra-container .p1-paragraph {
    margin-bottom: 32px;
    color: var(--color-contrast-dark-gray);
}

/* buttons */
.buttons {
    width: fit-content;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 25.5px;
}

.btn-primary,
.btn-secondary {
    min-width: 106px;
    width: fit-content;
    padding: 14px 20px;
    border: 2px solid var(--color-primary-red);
    border-radius: 8px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-secondary.active {
    background: transparent;
    color: var(--color-primary-red);
}

.btn-secondary[data-size="tiny"] {
    font-weight: 500;
    font-size: 12px;
    letter-spacing: var(--letter-spacing-disclaimer);
    height: 24px;
    padding: 0px 8px;
    vertical-align: bottom;
}

@media (max-width: 768px) {
    .btn-primary,
    .btn-secondary {
        font-size: 14px;
        line-height: 24px;
    }
}

/* collapse box component */
.collapse-box-list {
    list-style: none;
    max-width: 900px;
    width: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.collapse-box-list .collapse-box {
    counter-increment: li;
    background-color: var(--color-primary-light-gray);
    padding: 40px;
    border: 1.5px solid var(--color-primary-offwhite);
    border-radius: 24px;
    display: flex;
    gap: 24px;
}

.collapse-box::before {
    content: counter(li) '.';
    font-family: var(--font-headline-1);
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    color: var(--color-primary-red);
}

.collapse-box .collapse-box-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 32px;
}

.collapse-box-content .title {
    font-family: var(--font-headline-1);
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
}

.collapse-box-content .text {
    display: flex;
    flex-direction: column;
    gap: 32px;
    display: none;
}

.collapse-box-content .text a {
    color: #1D85B9;
    text-decoration: underline;
}

.collapse-box .collapse-box-toggle {
    width: 22px;
    height: 22px;
    position: relative;
}

.collapse-box-toggle::before,
.collapse-box-toggle::after {
    content: "";
    width: 2px;
    height: 100%;
    background-color: var(--color-primary-red);
    position: absolute;
    top: 50%;
    left: 50%;
    translate: -50% -50%;
}

.collapse-box-toggle::before {
    rotate: 90deg;
}

.collapse-box[data-collapsed="false"] .collapse-box-toggle::after {
    visibility: hidden;
    opacity: 0;
}

table th,
table td {
    padding: 10px;
}

@media (max-width: 980px) {
    .collapse-box-list .collapse-box {
        max-width: calc(100vw - 48px);
        padding: 40px 20px;
        gap: 16px;
    }

    table th,
    table td {
        padding: 10px 5px;
        font-size: 10px;
        text-transform: capitalize;
    }
}

@media (max-width: 580px) {
    .collapse-box .collapse-box-content {
        max-width: 80%;
    }
}

/* logged area */
.logged-area .container .buttons {
    max-width: 860px;
    width: 100%;
}

.logged-area .container .buttons .btn-primary,
.logged-area .container .buttons .btn-secondary {
    flex: 1;
}

.internal .logged-area-content {
    max-width: 1280px;
    width: 100%;
    background-color: var(--color-primary-light-gray);
    padding: 56px;
    border: 1.5px solid var(--color-primary-offwhite);
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.internal .logged-area-content .heading {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.internal .logged-area-content .heading strong {
    color: var(--color-primary-red);
}

.internal .logged-area-content .heading .heading-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 100px;
    row-gap: 18px;
}

.internal .logged-area-content .development {
    padding: 56px;
    text-align: center;
}

.internal .logged-area-content .form {
    max-width: 100%;
}

.internal .logged-area-content .form .form-container {
    padding: 0;
    margin: 0;
    border: none;
    gap: 40px;
}

.logged-area .logged-area-content .coupons {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-auto-rows: auto;
    gap: 32px;
}

.logged-area .logged-area-content .coupons .coupon-item {
    max-width: 256px;
    min-height: 256px;
    background-color: #DEDEDE;
    border-radius: 24px;
    position: relative;
    overflow: hidden;
}

.logged-area .logged-area-content .coupons .coupon-item.awarded {
    background-color: var(--color-contrast-dark-yellow);
}

.logged-area .logged-area-content .coupons .coupon-item .coupon-item-scratch {
    width: 100%;
    height: 100%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
    background-size: cover;
    padding: 32px;
    color: var(--color-primary-white);
    display: flex;
    flex-direction: column;
    gap: 18px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    transition: scale ease-in-out 0.3s;
}

.logged-area .logged-area-content .coupons .coupon-item .coupon-item-scratch .scratch-now {
    color: var(--color-contrast-dark-yellow);
    display: flex;
    align-items: center;
    gap: 8px;
}

.logged-area .logged-area-content .coupons .coupon-item .coupon-item-scratch .scratch-now::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    max-height: 15px;
}

.logged-area .logged-area-content .coupons .coupon-item .supply {
    margin-top: auto;
}

.logged-area .logged-area-content .coupons .coupon-item .coupon-item-content {
    height: 100%;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 17px;
    position: relative;
    z-index: 0;
}

.logged-area .logged-area-content .coupons .coupon-item .coupon-item-content .s2-subtitle {
    line-height: 156%;
}

.logged-area .logged-area-content .coupons .coupon-item .coupon-item-content .coupon-number {
    margin-top: auto;
}

.logged-area .logged-area-content .winner {
    display: flex;
    justify-content: center;
}

.logged-area .logged-area-content .winner .s1-subtitle {
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center;
    background-size: 50px;
    background-position: right;
    padding: 24px 55px 24px 0;
}

.logged-area .logged-area-content .numbers-container {
    padding: 0 32px;
    display: flex;
    flex-direction: column;
    gap: 56px;
}

.logged-area .logged-area-content .numbers-container .awarded-numbers {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.logged-area .logged-area-content .numbers-container .awarded-numbers .awarded-number-item {
    background-color: var(--color-contrast-dark-yellow);
    padding: 32px 56px;
    border-radius: 18px;
}

.logged-area .logged-area-content .numbers-container .awarded-numbers .awarded-number-item .awarded-number-item-wrapper {
    display: flex;
    align-items: center;
    gap: 28px;
}

.numbers-container .awarded-numbers .awarded-number-item .text {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 24px;
}

.numbers-container .awarded-numbers .awarded-number-item .image {
    max-width: 160px;
}

.logged-area .logged-area-content .numbers-container .numbers {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-auto-rows: auto;
    gap: 25px;
}

.logged-area .logged-area-content .numbers-container .numbers .number-item {
    background-color: #DEDEDE;
    border: 1.5px solid var(--color-primary-white);
    border-radius: 24px;
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.logged-area .logged-area-content .numbers-container .numbers .number-item.awarded {
    background-color: var(--color-contrast-dark-yellow);
}

.numbers-container .numbers .number-item .supply {
    margin-top: 12px;
}

.numbers-container .numbers .number-item.awarded .tag {
    color: var(--color-primary-red);
}


@media (max-width: 768px) {
    .internal .logged-area-content {
        max-width: calc(100vw - 48px);
        padding: 40px 32px;
    }

    .internal .logged-area-content .development {
        padding: 0;
    }

    .logged-area .logged-area-content .numbers-container {
        padding: 0;
    }

    .logged-area .logged-area-content .numbers-container .awarded-numbers .awarded-number-item {
        padding: 32px;
        flex-direction: column-reverse;
        align-items: flex-start;
    }

    .logged-area .logged-area-content .numbers-container .numbers {
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    }
}

/* winners */
.internal .container .buttons.v2 {
    max-width: calc(100vw - 48px);
    width: 100%;
    flex-wrap: wrap;
}

.internal .container .buttons.v2 .btn-primary,
.internal .container .buttons.v2 .btn-secondary {
    border-radius: 18px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.internal .container .buttons.v2 .btn-primary[disabled],
.internal .container .buttons.v2 .btn-secondary[disabled] {
    background-color: var(--color-primary-light-gray);
    border: 2px solid var(--color-primary-offwhite);
    color: #DEDEDE;
    cursor: not-allowed;
}

.internal .container .buttons.v2 .btn-primary[disabled] .date,
.internal .container .buttons.v2 .btn-secondary[disabled] .date {
    color: #DEDEDE;
}

.internal .container .buttons.v2 .btn-secondary {
    background-color: var(--color-primary-light-gray);
    border-color: var(--color-primary-offwhite);
}

.internal .container .buttons.v2 .btn-primary:has(.date),
.internal .container .buttons.v2 .btn-secondary:has(.date) {
    align-items: flex-start;
}

.internal .container .buttons.v2 .btn-primary .date,    
.internal .container .buttons.v2 .btn-secondary .date {
    font-family: var(--font-paragraph-2);
    font-weight: 600;
}

.internal .container .buttons.v2 .btn-secondary .date {
    color: var(--color-contrast-dark-gray);
}

.internal .logged-area-content .table-container {
    max-width: 1280px;
    overflow-x: auto;
}

.internal .logged-area-content .table-container table {
    width: 100%;
    margin: 16px 0;
}

.internal .logged-area-content table thead tr {
    position: relative;
}

.internal .logged-area-content table thead tr::after {
    content: "";
    width: 100%;
    height: 1.5px;
    background-color: var(--color-primary-offwhite);
    position: absolute;
    bottom: 0;
    left: 0;
}

.internal .logged-area-content table tbody tr td {
    padding-top: 40px;
}

.internal .logged-area-content table th,
.internal .logged-area-content table td {
    padding: 18px 0;
    text-align: left;
}

@media (max-width: 768px) {
    .internal .logged-area-content .table-container table {
        width: 100vw;
    }

    .internal .logged-area-content table th,
    .internal .logged-area-content table td {
        padding: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/internals.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iDAAiD;IACjD,mBAAmB;IACnB,iDAAiD;IACjD,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,8BAA8B;IAC9B,kCAAkC;IAClC,4CAA4C;IAC5C,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,iDAAiD;IACjD,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oEAA8E;IAC9E,wBAAwB;IACxB,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+FAAiG;IACjG,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,yCAAyC;IACzC,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;IAEI,cAAc;IACd,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA,YAAY;AACZ;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gDAAgD;IAChD,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI;;QAEI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;IACjD,aAAa;IACb,iDAAiD;IACjD,mBAAmB;IACnB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI;QACI,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;IACb;;IAEA;;QAEI,iBAAiB;QACjB,eAAe;QACf,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,iDAAiD;IACjD,aAAa;IACb,iDAAiD;IACjD,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oEAAmE;IACnE,sBAAsB;IACtB,aAAa;IACb,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gDAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gFAAoE;IACpE,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mDAAmD;IACnD,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;;AAGA;IACI;QACI,6BAA6B;QAC7B,kBAAkB;IACtB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;IAC3B;;IAEA;QACI,4DAA4D;IAChE;AACJ;;AAEA,YAAY;AACZ;IACI,6BAA6B;IAC7B,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,iDAAiD;IACjD,+CAA+C;IAC/C,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,iDAAiD;IACjD,2CAA2C;AAC/C;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;IAEI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,+CAA+C;IAC/C,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;;QAEI,UAAU;IACd;AACJ","sourcesContent":["body:has(.internal) {\n    display: flex;\n    flex-direction: column;\n}\n\n.internal {\n    max-width: 1328px;\n    padding: 0 24px;\n    margin: 0 auto;\n    color: var(--color-contrast-dark-gray);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n}\n\n.internal > .container {\n    gap: 90px;\n}\n\n.internal .container .comp-title strong {\n    color: var(--color-primary-red);\n}\n\n.internal .container .comp-title > .p1-paragraph {\n    color: var(--color-contrast-dark-gray);\n}\n\n@media (max-width: 768px) {\n    .internal .container {\n        gap: 50px;\n    }\n}\n\n/* rules */\n.rules {\n    max-width: 900px;\n    color: var(--color-contrast-dark-gray);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.rules .buttons {\n    margin-top: 58px;\n}\n\n/* contact us */\n.contact-us {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n}\n\n.contact-us .form {\n    max-width: 900px;\n}\n\n/* form component */\n.form {\n    max-width: 600px;\n    width: 100%;\n}\n\n.form:has(.form-sent-message) {\n    max-width: 688px;\n}\n\n.form .form-sent-message {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 50px;\n}\n\n.form .form-container {\n    background-color: var(--color-primary-light-gray);\n    margin-bottom: 56px;\n    border: 1.5px solid var(--color-primary-offwhite);\n    border-radius: 24px;\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n.form-container .title {\n    font-family: var(--font-headline-1);\n    font-weight: 600;\n    font-size: var(--font-size-h5);\n    line-height: var(--line-height-h3);\n    letter-spacing: var(--letter-spacing-normal);\n    color: var(--color-contrast-dark-gray);\n}\n\n.form-container .fields {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.form-container .fields .field {\n    width: 100%;\n    position: relative;\n}\n\n.form-container .fields .field.checkbox-field {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 8px;\n}\n\n.fields .field:not(.checkbox-field) label {\n    font-size: 14px;\n    line-height: 140%;\n    color: var(--color-contrast-dark-gray);\n    position: absolute;\n    top: 12px;\n    left: 18px;\n}\n\n.fields .field.checkbox-field label {\n    padding-top: 2px;\n    font-size: 12px;\n    line-height: 140%;\n    color: var(--color-contrast-dark-gray);\n}\n\n.fields .field input:not([type=\"checkbox\"]),\n.fields .field textarea {\n    width: 100%;\n    min-height: 78px;\n    padding: 42px 18px 12px;\n    border: 1.5px solid var(--color-primary-offwhite);\n    border-radius: 8px;\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-contrast-dark-gray);\n}\n\n.fields .field textarea {\n    min-height: 200px;\n}\n\n.fields .field .toggle-password {\n    width: 28px;\n    height: 80px;\n    background: url(\"../../public/images/icon-show-password.svg\") no-repeat center;\n    background-size: contain;\n    position: absolute;\n    top: 0;\n    right: 20px;\n    transition: background-image ease-in 0.2s;\n}\n\n.fields .field .help-text {\n    padding: 15px 0;\n}\n\n.fields .field .help-text ul {\n    padding-left: 20px;\n    margin: 0;\n}\n\n.fields .field input[type=\"checkbox\"] {\n    width: 24px;\n    height: 24px;\n    background: var(--color-primary-white) url(\"../../public/images/icon-check.svg\") no-repeat center;\n    margin: 0;\n    border: 1.5px solid #DD1D21;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color ease-in 0.2s;\n    appearance: none;\n    -webkit-appearance: none;\n}\n\n.fields .field input[type=\"checkbox\"]:checked {\n    background-color: var(--color-primary-red);\n}\n\n.fields .field .error,\n.error-message {\n    margin: 18px 0;\n    font-family: var(--font-headline-1);\n    font-size: 12px;\n    line-height: 140%;\n    color: var(--color-primary-red);\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.fields a {\n    font-size: 12px;\n    line-height: 140%;\n    color: #1D85B9;\n    text-decoration: underline;\n}\n\n.internal .extra-container {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.internal .extra-container .title {\n    color: var(--color-primary-red);\n}\n\n.internal .extra-container .title b {\n    color: var(--color-contrast-dark-gray);\n}\n\n.internal .extra-container .p1-paragraph {\n    margin-bottom: 32px;\n    color: var(--color-contrast-dark-gray);\n}\n\n/* buttons */\n.buttons {\n    width: fit-content;\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 25.5px;\n}\n\n.btn-primary,\n.btn-secondary {\n    min-width: 106px;\n    width: fit-content;\n    padding: 14px 20px;\n    border: 2px solid var(--color-primary-red);\n    border-radius: 8px;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 24px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.btn-secondary.active {\n    background: transparent;\n    color: var(--color-primary-red);\n}\n\n.btn-secondary[data-size=\"tiny\"] {\n    font-weight: 500;\n    font-size: 12px;\n    letter-spacing: var(--letter-spacing-disclaimer);\n    height: 24px;\n    padding: 0px 8px;\n    vertical-align: bottom;\n}\n\n@media (max-width: 768px) {\n    .btn-primary,\n    .btn-secondary {\n        font-size: 14px;\n        line-height: 24px;\n    }\n}\n\n/* collapse box component */\n.collapse-box-list {\n    list-style: none;\n    max-width: 900px;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n}\n\n.collapse-box-list .collapse-box {\n    counter-increment: li;\n    background-color: var(--color-primary-light-gray);\n    padding: 40px;\n    border: 1.5px solid var(--color-primary-offwhite);\n    border-radius: 24px;\n    display: flex;\n    gap: 24px;\n}\n\n.collapse-box::before {\n    content: counter(li) '.';\n    font-family: var(--font-headline-1);\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 130%;\n    color: var(--color-primary-red);\n}\n\n.collapse-box .collapse-box-content {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    gap: 32px;\n}\n\n.collapse-box-content .title {\n    font-family: var(--font-headline-1);\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 130%;\n}\n\n.collapse-box-content .text {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n    display: none;\n}\n\n.collapse-box-content .text a {\n    color: #1D85B9;\n    text-decoration: underline;\n}\n\n.collapse-box .collapse-box-toggle {\n    width: 22px;\n    height: 22px;\n    position: relative;\n}\n\n.collapse-box-toggle::before,\n.collapse-box-toggle::after {\n    content: \"\";\n    width: 2px;\n    height: 100%;\n    background-color: var(--color-primary-red);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    translate: -50% -50%;\n}\n\n.collapse-box-toggle::before {\n    rotate: 90deg;\n}\n\n.collapse-box[data-collapsed=\"false\"] .collapse-box-toggle::after {\n    visibility: hidden;\n    opacity: 0;\n}\n\ntable th,\ntable td {\n    padding: 10px;\n}\n\n@media (max-width: 980px) {\n    .collapse-box-list .collapse-box {\n        max-width: calc(100vw - 48px);\n        padding: 40px 20px;\n        gap: 16px;\n    }\n\n    table th,\n    table td {\n        padding: 10px 5px;\n        font-size: 10px;\n        text-transform: capitalize;\n    }\n}\n\n@media (max-width: 580px) {\n    .collapse-box .collapse-box-content {\n        max-width: 80%;\n    }\n}\n\n/* logged area */\n.logged-area .container .buttons {\n    max-width: 860px;\n    width: 100%;\n}\n\n.logged-area .container .buttons .btn-primary,\n.logged-area .container .buttons .btn-secondary {\n    flex: 1;\n}\n\n.internal .logged-area-content {\n    max-width: 1280px;\n    width: 100%;\n    background-color: var(--color-primary-light-gray);\n    padding: 56px;\n    border: 1.5px solid var(--color-primary-offwhite);\n    border-radius: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n\n.internal .logged-area-content .heading {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.internal .logged-area-content .heading strong {\n    color: var(--color-primary-red);\n}\n\n.internal .logged-area-content .heading .heading-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    column-gap: 100px;\n    row-gap: 18px;\n}\n\n.internal .logged-area-content .development {\n    padding: 56px;\n    text-align: center;\n}\n\n.internal .logged-area-content .form {\n    max-width: 100%;\n}\n\n.internal .logged-area-content .form .form-container {\n    padding: 0;\n    margin: 0;\n    border: none;\n    gap: 40px;\n}\n\n.logged-area .logged-area-content .coupons {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    grid-auto-rows: auto;\n    gap: 32px;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item {\n    max-width: 256px;\n    min-height: 256px;\n    background-color: #DEDEDE;\n    border-radius: 24px;\n    position: relative;\n    overflow: hidden;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item.awarded {\n    background-color: var(--color-contrast-dark-yellow);\n}\n\n.logged-area .logged-area-content .coupons .coupon-item .coupon-item-scratch {\n    width: 100%;\n    height: 100%;\n    background: url(/public/images/bg-scratchcard.png) no-repeat center;\n    background-size: cover;\n    padding: 32px;\n    color: var(--color-primary-white);\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    transition: scale ease-in-out 0.3s;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item .coupon-item-scratch .scratch-now {\n    color: var(--color-contrast-dark-yellow);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item .coupon-item-scratch .scratch-now::after {\n    content: url(/public/images/coupon-vector.svg);\n    max-height: 15px;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item .supply {\n    margin-top: auto;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item .coupon-item-content {\n    height: 100%;\n    padding: 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 17px;\n    position: relative;\n    z-index: 0;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item .coupon-item-content .s2-subtitle {\n    line-height: 156%;\n}\n\n.logged-area .logged-area-content .coupons .coupon-item .coupon-item-content .coupon-number {\n    margin-top: auto;\n}\n\n.logged-area .logged-area-content .winner {\n    display: flex;\n    justify-content: center;\n}\n\n.logged-area .logged-area-content .winner .s1-subtitle {\n    background: transparent url(/public/gifs/party.gif) no-repeat center;\n    background-size: 50px;\n    background-position: right;\n    padding: 24px 55px 24px 0;\n}\n\n.logged-area .logged-area-content .numbers-container {\n    padding: 0 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 56px;\n}\n\n.logged-area .logged-area-content .numbers-container .awarded-numbers {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.logged-area .logged-area-content .numbers-container .awarded-numbers .awarded-number-item {\n    background-color: var(--color-contrast-dark-yellow);\n    padding: 32px 56px;\n    border-radius: 18px;\n}\n\n.logged-area .logged-area-content .numbers-container .awarded-numbers .awarded-number-item .awarded-number-item-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 28px;\n}\n\n.numbers-container .awarded-numbers .awarded-number-item .text {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    gap: 24px;\n}\n\n.numbers-container .awarded-numbers .awarded-number-item .image {\n    max-width: 160px;\n}\n\n.logged-area .logged-area-content .numbers-container .numbers {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    grid-auto-rows: auto;\n    gap: 25px;\n}\n\n.logged-area .logged-area-content .numbers-container .numbers .number-item {\n    background-color: #DEDEDE;\n    border: 1.5px solid var(--color-primary-white);\n    border-radius: 24px;\n    padding: 24px 32px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.logged-area .logged-area-content .numbers-container .numbers .number-item.awarded {\n    background-color: var(--color-contrast-dark-yellow);\n}\n\n.numbers-container .numbers .number-item .supply {\n    margin-top: 12px;\n}\n\n.numbers-container .numbers .number-item.awarded .tag {\n    color: var(--color-primary-red);\n}\n\n\n@media (max-width: 768px) {\n    .internal .logged-area-content {\n        max-width: calc(100vw - 48px);\n        padding: 40px 32px;\n    }\n\n    .internal .logged-area-content .development {\n        padding: 0;\n    }\n\n    .logged-area .logged-area-content .numbers-container {\n        padding: 0;\n    }\n\n    .logged-area .logged-area-content .numbers-container .awarded-numbers .awarded-number-item {\n        padding: 32px;\n        flex-direction: column-reverse;\n        align-items: flex-start;\n    }\n\n    .logged-area .logged-area-content .numbers-container .numbers {\n        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    }\n}\n\n/* winners */\n.internal .container .buttons.v2 {\n    max-width: calc(100vw - 48px);\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n.internal .container .buttons.v2 .btn-primary,\n.internal .container .buttons.v2 .btn-secondary {\n    border-radius: 18px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.internal .container .buttons.v2 .btn-primary[disabled],\n.internal .container .buttons.v2 .btn-secondary[disabled] {\n    background-color: var(--color-primary-light-gray);\n    border: 2px solid var(--color-primary-offwhite);\n    color: #DEDEDE;\n    cursor: not-allowed;\n}\n\n.internal .container .buttons.v2 .btn-primary[disabled] .date,\n.internal .container .buttons.v2 .btn-secondary[disabled] .date {\n    color: #DEDEDE;\n}\n\n.internal .container .buttons.v2 .btn-secondary {\n    background-color: var(--color-primary-light-gray);\n    border-color: var(--color-primary-offwhite);\n}\n\n.internal .container .buttons.v2 .btn-primary:has(.date),\n.internal .container .buttons.v2 .btn-secondary:has(.date) {\n    align-items: flex-start;\n}\n\n.internal .container .buttons.v2 .btn-primary .date,    \n.internal .container .buttons.v2 .btn-secondary .date {\n    font-family: var(--font-paragraph-2);\n    font-weight: 600;\n}\n\n.internal .container .buttons.v2 .btn-secondary .date {\n    color: var(--color-contrast-dark-gray);\n}\n\n.internal .logged-area-content .table-container {\n    max-width: 1280px;\n    overflow-x: auto;\n}\n\n.internal .logged-area-content .table-container table {\n    width: 100%;\n    margin: 16px 0;\n}\n\n.internal .logged-area-content table thead tr {\n    position: relative;\n}\n\n.internal .logged-area-content table thead tr::after {\n    content: \"\";\n    width: 100%;\n    height: 1.5px;\n    background-color: var(--color-primary-offwhite);\n    position: absolute;\n    bottom: 0;\n    left: 0;\n}\n\n.internal .logged-area-content table tbody tr td {\n    padding-top: 40px;\n}\n\n.internal .logged-area-content table th,\n.internal .logged-area-content table td {\n    padding: 18px 0;\n    text-align: left;\n}\n\n@media (max-width: 768px) {\n    .internal .logged-area-content .table-container table {\n        width: 100vw;\n    }\n\n    .internal .logged-area-content table th,\n    .internal .logged-area-content table td {\n        padding: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
